export default "__VITE_ASSET__Bn8ttD1x__"